import { render } from "./TrackWaveform.vue?vue&type=template&id=0dcc9b59&ts=true"
import script from "./TrackWaveform.vue?vue&type=script&lang=ts"
export * from "./TrackWaveform.vue?vue&type=script&lang=ts"

import "./TrackWaveform.vue?vue&type=style&index=0&id=0dcc9b59&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__